import { useEffect, useRef, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import MessageLayout from "@/components/MessageComponent/MessageLayout";
import "./index.less";
import { MessageMenuType } from "@/types/message";




/**
 * 消息中心
 * @returns 
 */
function MessageCenter() {
  const navigate=useNavigate();
  const location=useLocation();
  const [selectKey, setSelectKey] = useState<string>("");//当前选中的菜单
  const asideMenuRef = useRef<MessageMenuType[]>([{
    label: "全部消息",
    key: "all",
    value: "all",
  },{
    label: "未读消息",
    key: "unread",
    value: "unread",
  },{
    label: "已读消息",
    key: "read",
    value: "read",
  }]);// 消息菜单

  /**
   * 菜单点击回调
   * @param key 
   */
  const menuClick=(data:MessageMenuType)=>{
    navigate('/message/list?type='+data.value);
  }
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const type = searchParams.get("type");
    const key = asideMenuRef.current.find(item => item.value === type)?.key;
    console.log('location',location);
    if (location.pathname === "/message/detail") {
      setSelectKey("");
    }else{
      setSelectKey(key || "all");
    }
    
  },[location.search])
  return (
    <>
      <MessageLayout 
        title="消息中心"
        menus={asideMenuRef.current} 
        activeMenuKey={selectKey} 
        menuClick={menuClick}  
      >
        <Outlet/>
      </MessageLayout>
    </>
  );
}

export default MessageCenter;
